import React from 'react';

function HeroSection({ scrollToSection }) {
    return (
        <section id="home" className="hero-section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7">
                        <h1 className="hero-title">
                            Идеальные потолки для вашего дома
                        </h1>
                        <p className="hero-subtitle">
                            Профессиональный монтаж натяжных потолков с гарантией 10 лет.
                            Более 1000 довольных клиентов
                        </p>
                    </div>
                    <div className="col-lg-5 text-center mt-5 mt-lg-0">
                        <div className="stats-inline d-flex justify-content-center gap-4">
                            <div className="text-center">
                                <h2 className="text-white fw-bold">10+</h2>
                                <p className="text-white-50">лет опыта</p>
                            </div>
                            <div className="text-center">
                                <h2 className="text-white fw-bold">5000+</h2>
                                <p className="text-white-50">проектов</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroSection;